import { ApiRequestInterceptor } from "../Services/apiRequest";
import { CATEGORIAS } from "../Constants/Endpoints";

export const fetchRestaurantsByCategory = async (categoriaPrincipal) => {
    if (!categoriaPrincipal) {
        throw new Error("categoriaPrincipal es requerida");
    }

    // Reemplaza {categoriaPrincipal} en la URL
    const url = CATEGORIAS.categorias.replace(
        "{categoriaPrincipal}",
        encodeURIComponent(categoriaPrincipal)
    );

    const res = await ApiRequestInterceptor(url, "GET");
    const code = res.code ?? res.status ?? 0;
    const data = res.data ?? res;

    if (code === 200) {
        // Tu Lambda responde { items, count }
        return data.items ?? [];
    }

    throw new Error("Error al obtener restaurantes por categoría");
};